export default __webpack_public_path__ + "static/greenBack-98741571286e69e789fe8a3e343c3bb8.jpg";